import { EApplicantType, EFinancingProgram } from '@if/core/types'
import { ActionButton, useConfirmDialog } from '@if/mui'
import { useResendIdentityVerification } from '@src/data/api/credit-api/identity-verification-api'
import { Dispatch } from 'react'
import { useTranslation } from 'react-i18next'

interface Props {
  creditApplicationId: string
  financingProgramId: EFinancingProgram
  applicantType: EApplicantType
  setError: Dispatch<Error>
}

const ResendIdentityVerificationButton = ({
  creditApplicationId,
  financingProgramId,
  applicantType,
  setError,
}: Props) => {
  const { t } = useTranslation()

  const [resendIdentityVerification, isPending] = useResendIdentityVerification(
    creditApplicationId,
    financingProgramId,
    applicantType,
  )

  const confirmResend = useConfirmDialog({
    title: t('documentSectionHeaders.resendIdentityVerificationConfirmTitle'),
    message: t('documentSectionHeaders.resendIdentityVerificationConfirmMessage'),
    onConfirm: async () => {
      try {
        await resendIdentityVerification()
      } catch (e) {
        setError(e as Error)
      }
    },
  })

  return (
    <ActionButton size="small" loading={isPending} onClick={() => void confirmResend.open()}>
      {t('documentSectionHeaders.resendIdentityVerification')}
    </ActionButton>
  )
}

export default ResendIdentityVerificationButton
